import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './Family.css';
import { Box, Grid } from '@mui/material';

const Family = () => {
  const { t } = useTranslation();

  return (
    <div className='family' id='family' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid container className='body'>
        <Grid container item xs={12} md={5} className='left' >
          <label className='mobile'>{t(`family.label`)}</label>
          <h1 className='mobile'>{t(`family.title`)}<span>{t(`family.title2`)}</span></h1>
          <img className='image1' src={Images.tiim.family} alt='family' />
          <Box>
            <h2>{t(`family.benefits`)}</h2>
            {
              t(`family.benefitsList`).map((item, index) => (
                <Grid key={index} container flexDirection={'row'} gap={2} >
                  <img className='check' src={Images.icons.circleCheck2} alt={'check'} />
                  <h4>{item}</h4>
                </Grid>
              ))
            }
          </Box>
        </Grid>
        <Grid container item xs={12} md={7} className='right' >
          <label className='desktop'>{t(`family.label`)}</label>
          <h1 className='desktop'>{t(`family.title`)}<span>{t(`family.title2`)}</span></h1>
          <img className='image2' src={Images.tiim.family2} alt='family' />
          <h3>{t(`family.subtitle`)}</h3>
          <pre>{t(`family.description`)}</pre>
          <img className='stores' src={Images.tiim.stores} alt='stores' />
        </Grid>
      </Grid>
    </div>

  )
}

export default Family 